import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import NewVendorForm from "./NewVendorForm";

function getModalStyle() {
  const top = 40;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "auto",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
    maxHeight: "600px",
    overflow: "scroll",
  },
}));

export default (props) => {
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const open = props.open;
  const handleClose = props.handleClose;
  const submitNewVendor = props.submitNewVendor;

  return (
    <Modal open={open} onClose={handleClose}>
      <div style={modalStyle} className={classes.paper}>
        <h1 style={{ textAlign: "left" }}>New Vendor Info</h1>

        <NewVendorForm
          handleClose={handleClose}
          submitNewVendor={submitNewVendor}
        />
      </div>
    </Modal>
  );
};
